export enum TipoPrecioReporte {
    PreciosSubidos = 0,
    PreciosAprobados = 1,
    PreciosFacturados = 2
}